import { render, staticRenderFns } from "./xianzhi_dingzhi.vue?vue&type=template&id=7bfad369&scoped=true"
import script from "./xianzhi_dingzhi.vue?vue&type=script&lang=js"
export * from "./xianzhi_dingzhi.vue?vue&type=script&lang=js"
import style0 from "./xianzhi_dingzhi.vue?vue&type=style&index=0&id=7bfad369&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfad369",
  null
  
)

export default component.exports